import { FC } from 'react';
import { Link, TrackedLink } from '../../../../../../../shared/frontend/components/link';
import { scaledAssetUrl } from '../../../../../../../shared/frontend/services/assetResolverService';

export const SidebarHouseAd: FC<any> = (props) => {
  const link = props.ad.linkUrl.startsWith('/') ? (
    <Link to={props.ad.linkUrl} target="_blank">
      <img src={props.ad.imageUrl} />
    </Link>
  ) : (
    <TrackedLink href={props.ad.linkUrl} rel="noopener" target="_blank">
      <img
        src={scaledAssetUrl(props.ad.imageUrl, {
          width: 600,
          quality: 75
        })}
      />
    </TrackedLink>
  );
  return <section style={{ border: '2px solid #ffbd0a' }}>{link}</section>;
};
